import React, { Fragment } from 'react';
import { Header } from 'semantic-ui-react';

import Passenger from './Passenger';

const PassengersInfo = ({ values, ...props }) => {
  const { passengers, passengerTicketId } = values;
  const errors = props.errors && props.errors.passengers;
  const touched = props.touched && props.touched.passengers;
  return (
    <Fragment>
      <Header as="h4">Passenger Information</Header>
      {passengers
        ? passengers.map((passenger, index) => {
            const passenger_error = errors ? errors[index] : undefined;
            const passenger_touched = touched ? touched[index] : undefined;
            return (
              <Passenger
                {...props}
                key={passenger.id}
                errors={passenger_error}
                touched={passenger_touched}
                passenger={passenger}
                index={index}
                passengerTicketId={passengerTicketId}
              />
            );
          })
        : null}
    </Fragment>
  );
};

export default PassengersInfo;



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/Form/PassengersInfo.js